<div class="sh-fixed-header-panel">
  <div class="sh-fixed-header-panel__head">
    <div class="sh-fixed-header-panel__head__title">{{ "plugins.record-tree.title" | translate }}</div>
  </div>
  <div class="sh-fixed-header-panel__content">
    @if (loading$ | async) {
      {{ "ui.loading" | translate }}
    }

    @if (recordTreeNodes$ | async; as recordTreeNodes) {
      @if (recordTreeNodes.length > 0) {
        <div class="sh-facet-list">
          <sh-tree-viewer
            [nodes]="recordTreeNodes"
            [hideRootNodes]="false"
            [multiple]="false"
            [loadingMsg]="'ui.loading' | translate"
            [getChildrenFct]="getNodeNarrowerRecordTree"
            [loadMoreMsg]="'ui.load-more' | translate"
            (selectedNodes)="onSelectedNodes($event)"
            (updatedNodes)="onUpdatedNodes($event)"
          ></sh-tree-viewer>
        </div>
      } @else {
        {{ "ui.loading-failed" }}
      }
    }
  </div>
</div>

